export function addPromotionItems(promoItems) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'ADD_PROMOTION_ITEMS',
                payload: promoItems
            });
            resolve(true)
        });
    }
};

export const resetPromotionItems = () => ({
    type: 'RESET_PROMOTION_ITEMS'
});